// billing-plugin/common/schemas/collections/chargeables.js
import { z } from "zod";

const ChargeableSchema = z.object({
    _id: z.string().optional(),
    targetId: z.string().describe("The subscriptionId."),
    
    lineItemId: z.string().describe("The featureKey of the ActiveBillingLineItem this belongs to."),
    entityId: z.string().describe("The ID of the actual item being billed (e.g., userId, channelConfigId)."),
    
    chargeType: z.enum(['one-time', 'recurring']),
    status: z.enum(['active', 'cancelled']).default('active'),
    
    cost: z.number().int().describe("The cost for this specific entity's billing period in cents."),
    description: z.string(),
    
    lastChargedAt: z.coerce.date().optional().nullable(),
    nextChargeAt: z.coerce.date().optional().nullable(),
    
    createdAt: z.coerce.date(),
});

export default ChargeableSchema;